import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Countries from 'views/partner/countries/countries'; // Importing Countries view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnerCountriesView class extends JetView to create a specific view for partner countries.
 */
export default class PartnerCountriesView extends JetView {
    /**
     * Configures the UI components of the PartnerCountriesView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disables responsive behavior for the cell
            css: 'cajeros', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applies the current theme
                    elements: [
                        { view: 'label', label: _('Países') }, // Label for the toolbar
                        {
                            type: 'wide', // Type of the element
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Countries, // Including the Countries view
            ],
        };

        webix.ui.fullScreen(); // Sets the UI to full screen mode

        return {
            view: 'form', // Form component
            type: 'wide', // Type of the form
            responsive: true, // Enables responsive behavior
            scroll: true, // Enables scrolling
            rows: [left], // Rows of the form containing the left panel
        };
    }
}

// FILE DOCUMENTED
